import { oauthLogger } from '../utils/logging.utils';
export class LoginCookieService {
  static setLoginCookie(status) {
    const cookie = {
      stati: [{
          umgebung: this.umgebung,
          status,
          time: Date.now() - this.TIMING_CORRECTION_MS
        }]
    };
    // schon vorhandener cookie? -> aktualisieren
    const oldcookie = this.getLoginSessionCookie();
    if (oldcookie !== null) {
      oldcookie.stati.forEach(obj => {
        if (obj.umgebung !== this.umgebung) {
          cookie.stati.push(obj);
        }
      });
    }
    this.setCookie(cookie);
  }
  static getLoginStatus() {
    const cookie = this.getLoginSessionCookie();
    if (cookie !== null) {
      // status entsprechend der angefragten Umgebung
      if (this.umgebung) {
        // extra object da aus foreach schleife kein wert zurückgegeben werden kann
        const status = {
          returnstatus: this.LoginStatus.UNDEFINED
        };
        cookie.stati.forEach(obj => {
          if (obj.umgebung === this.umgebung) {
            status.returnstatus = this.checkDate(obj);
          }
        });
        return status.returnstatus;
      }
    }
    return this.LoginStatus.UNDEFINED;
  }
  /**
   * Checkt den LoginStatus auf loggedin
   * Vergleicht das Alter der aktuellen Login Session mit einem übergebenen Datum
   * Damit kann geprüft werden, ob ein jwt/baicon aus dem Cache noch gültig ist
   * ist oamhost null wird immer true zurückgegeben (Möglichkeit zum überspringen des checks für z.B. oag-token)
   *
   * @param issueDate
   * @return true wenn
   *          a: LoginStatus logged in
   *          b: übergebendes issueDate jünger als letzte Aktualisierung des BaLoginSession Cookies
   */
  static isValidTokenSession(issueDate) {
    // valid nur wenn angemeldet
    const status = this.getLoginStatus();
    if (status !== this.LoginStatus.LOGGEDIN) {
      return false;
    }
    // Zeit vergleichen
    const cookie = this.getLoginSessionCookie();
    // extra object da aus foreach schleife kein wert zurückgegeben werden kann
    const time = {
      time: Date.now()
    };
    if (cookie !== null) {
      // status entsprechend der angefragten Umgebung
      if (this.umgebung) {
        cookie.stati.forEach(obj => {
          if (obj.umgebung === this.umgebung) {
            time.time = obj.time;
          }
        });
      }
    }
    return time.time < issueDate;
  }
  /*
  Host ist für einige Testumgebungen gleich (ibaintern.de -> sint, ltu; ebaintern.de -> stuwc1-3, pint)
  Eine saubere Abmeldung während der Tests ist nicht gewährleistet, deshalb muss der cookie die entsprechende Umgebung beachten
  In Produktion gibt es nur einen OAM und damit kann es auch keine mehrere Anmeldungen geben
   */
  static setUmgebungFromOamHost(oamhost) {
    // (Test) Umgebung aus OAM Host auslesen
    // https://oam-[umgebung]...
    // default prod
    if (!oamhost) {
      this.umgebung = 'prod';
    }
    else {
      let umg = oamhost.split('.')[0];
      const n = umg.search('-');
      if (n >= 0) {
        umg = umg.substr(n + 1);
        this.umgebung = umg;
      }
      else {
        this.umgebung = 'prod';
      }
    }
  }
  static setCookie(cookie) {
    const domain = this.getDomain();
    const cvalue = this.encodeCookieValue(cookie);
    document.cookie = 'BaLoginSession=' + cvalue + ';domain=' + domain + ';path=/;samesite=lax;secure;';
  }
  static encodeCookieValue(cookie) {
    const b64 = btoa(JSON.stringify(cookie));
    return b64.split('=').join('');
  }
  static checkDate(obj) {
    if (obj.status === this.LoginStatus.LOGGEDIN) {
      // check time
      // Erstellung + 30min
      const dt1 = obj.time + 1800000;
      // jetzt
      const dt2 = Date.now();
      // älter als 30min -> abgelaufen
      if (dt1 < dt2) {
        return this.LoginStatus.UNKNOWN;
      }
    }
    return obj.status;
  }
  static getLoginSessionCookie() {
    const name = 'BaLoginSession=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (const c of ca) {
      let ctemp = c;
      while (ctemp.charAt(0) === ' ') {
        ctemp = ctemp.substring(1);
      }
      if (ctemp.indexOf(name) === 0) {
        const cobj = this.decodeCookieValue(ctemp.substring(name.length, ctemp.length));
        if (!cobj) {
          // return unknown
          return {
            stati: [
              {
                umgebung: this.umgebung,
                status: this.LoginStatus.UNKNOWN,
                time: Date.now()
              }
            ]
          };
        }
        return cobj;
      }
    }
    return null;
  }
  static decodeCookieValue(val) {
    try {
      // base64 cookie?
      if (!val.startsWith('{')) {
        val = atob(val);
      }
      return JSON.parse(val);
    }
    catch (e) {
      oauthLogger.warn(e);
    }
    return null;
  }
  static getDomain() {
    const parts = document.location.host.split('.');
    let domain = '';
    if (parts.length < 2) {
      domain = document.location.host;
    }
    else {
      for (let i = parts.length - 2; i < parts.length; i++) {
        domain += '.' + parts[i];
      }
    }
    // ohne port
    return domain.split(':')[0];
  }
}
LoginCookieService.LoginStatus = {
  // user logged in
  LOGGEDIN: 'loggedin',
  // user logged aut
  LOGGEDOUT: 'loggedout',
  // cookie older than 30min
  UNKNOWN: 'unknown',
  // no BaLoginSession cookie
  UNDEFINED: 'undefined',
};
LoginCookieService.umgebung = 'prod';
// Timing Korrektur für die Gültigkeit der Session (10s)
LoginCookieService.TIMING_CORRECTION_MS = 10000;
//# sourceMappingURL=login-cookie.service.js.map
